export default "__VITE_ASSET__DjhhRLsq__"